import { IBookingAllocationState } from './types';

/**
 * Convert a decimal dollar amount to cents.
 * Handles null/undefined safely, rounds to avoid floating point issues.
 */
export const dollarsToCents = (value: number | null | undefined): number => {
  return Math.round((value ?? 0) * 100);
};

/**
 * Convert cents to decimal dollar amount.
 */
export const centsToDollars = (cents: number): number => {
  return cents / 100;
};

/**
 * Calculate total allocated to bookings from allocation state.
 * Only includes selected bookings.
 */
export const calculateTotalBookingsAllocatedCents = (
  bookingAllocations: IBookingAllocationState[]
): number => {
  return bookingAllocations
    .filter(a => a.isSelected)
    .reduce((sum, a) => sum + a.toAllocateCents, 0);
};

/**
 * Calculate balance remaining to allocate.
 * Returns 0 instead of -0 to avoid display issues.
 */
export const calculateBalanceToAllocateCents = (
  totalReceiptCents: number,
  totalBookingsAllocatedCents: number,
  totalDepositAllocatedCents: number
): number => {
  const balance = totalReceiptCents - totalBookingsAllocatedCents - totalDepositAllocatedCents;
  // Round to whole cents and normalize -0 to 0
  return Math.round(balance) || 0;
};

/**
 * Format an ISO date string as "DD Mon YY" (e.g., "28 Jun 25").
 * Used for processing history version labels.
 */
export const formatDateShort = (isoDate: string): string => {
  const date = new Date(isoDate);
  const day = date.getDate();
  const month = date.toLocaleDateString('en-GB', { month: 'short' });
  const year = date.getFullYear().toString().slice(-2);
  return `${day} ${month} ${year}`;
};
